import { createApp } from "vue";
import { createLogto } from "@logto/vue";
import App from "./App.vue";
import { router } from "./router";
import { logtoConfig } from "./logto";
import "./styles.css";

createApp(App).use(createLogto, logtoConfig).use(router).mount("#app");
